var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"multiselect__tag",style:({ 'background-color': _vm.color, 'border-color': _vm.borderColor, color: _vm.textColor })},[_c('span',[_vm._v(_vm._s(_vm.option))])])}
var staticRenderFns = []

export { render, staticRenderFns }